<template lang="html">
  <div v-if="loading" class="loading-wrapper" :class="{small: appSmall}">
    <v-progress-circular
      :size="30"
      color="primary"
      indeterminate
    />
  </div>
  <v-select
    v-else-if="multiple"
    dense
    ref="selectComponent"
    multiple
    outlined
    single-line
    hide-details
    :value="value"
    @input="select"
    :items="groupedAlertConditionTypes"
    :append-icon="multiple && value && value.length ? 'fa-times' : undefined"
    @click:append="clearAll"
    :disabled="loading"
  >
    <template v-slot:prepend-item v-if="multiple">
      <v-list-item
        ripple
        @click="selectAll"
      >
        <v-list-item-action>
          <v-icon :color="value && value.length > 0 ? 'primary' : ''">{{ selectAllIcon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Select All</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <div v-if="multiple">
        <div v-if="!numChips && index === 0">
          <span>{{ value.length }} selected</span>
        </div>
        <div v-else-if="!!numChips">
          <v-chip v-if="index < numChips">
            <span># {{ item.text }}</span>
          </v-chip>
          <span
            v-if="value && value.length && index === numChips"
            class="caption"
          >(+{{ value.length - numChips }} others)</span>
        </div>
      </div>
      <div class="selection-label" :class="{small: appSmall}" v-else>{{ item.text }}</div>
    </template>
    <template
      v-slot:item="data"
    >
      <template>
        <!-- Divider and Header-->
        <div v-if="data.item.header">
          <v-list-item-content v-text="data.item.header" style="border-bottom: 1px #808080 solid;" />
        </div>
        <template v-else>
          <!-- Normal item -->
          <v-list-item-action>
            <v-checkbox
              color="primary"
              :input-value="(multiple && value && value.includes(data.item.value)) || (!multiple && value === data.item.value)" :value="(multiple && value && value.includes(data.item.value)) || (!multiple && value === data.item.value)"
            />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ data.item.text }} {{data.item.value}}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </template>
    </template>
  </v-select>
  <v-select
    v-else
    dense
    ref="selectComponent"
    outlined
    single-line
    hide-details
    :value="value"
    @input="select"
    :items="groupedAlertConditionTypes"
    :disabled="loading"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Array],
      default () {
        if (this.multiple) {
          return []
        }
        return null
      }
    },
    defaultSelectAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      initialLoading: true
    }
  },
  computed: {
    numChips () {
      return this.appSmall ? 0 : 2
    },
    loading () {
      return this.alertConditionTypesLoading || this.initialLoading
    },
    ...mapState('alertConditionTypes', {
      alertConditionTypesLoading: 'loading',
      alertConditionTypes: 'data'
    }),
    groupedAlertConditionTypes () {
      let groups = [
        { header: 'Applied Stretch', disabled: true },
        ...this.alertConditionTypes.filter((field) => field.text && field.text.includes('Applied Stretch')).map(field => ({ text: field.text, value: field.id })),
        { header: 'Revolutions', disabled: true },
        ...this.alertConditionTypes.filter((field) => field.text && field.text.includes('Revolutions')).map(field => ({ text: field.text, value: field.id })),
        { header: 'Unwind', disabled: true },
        ...this.alertConditionTypes.filter((field) => field.text && field.text.includes('Unwind')).map(field => ({ text: field.text, value: field.id })),
        { header: 'Other', disabled: true },
        ...this.alertConditionTypes.filter((field) =>
          field.id &&
          field.text &&
          !field.text.includes('Applied Stretch') &&
          !field.text.includes('Revolutions') &&
          !field.text.includes('Unwind')
        ).sort((a, b) => (a.text < b.text) ? -1 : (a.text > b.text) ? 1 : 0).map(field => ({ text: field.text, value: field.id }))
      ]
      return groups
    },
    selectAllIcon () {
      if (!this.multiple) {
        return
      }
      if (this.value && this.value.length === this.alertConditionTypes.length) {
        return 'fa-check-square'
      } else if (this.value && this.value.length) {
        return 'fa-minus-square'
      }
      return 'fa-square'
    }
  },
  methods: {
    ...mapActions('alertConditionTypes', {
      findAlertConditionTypes: 'find'
    }),
    clearAll ($event) {
      $event.stopPropagation()
      this.$emit('input', [])
    },
    selectAll () {
      if (this.value && this.value.length) {
        this.$emit('input', [])
      } else {
        this.$emit('input', this.alertConditionTypes.map(m => m.id))
        this.$refs.selectComponent.blur()
      }
    },
    select (value) {
      console.log('select', value)
      this.$emit('input', value)
    }
  },
  async created () {
    this.initialLoading = true
    try {
      await Promise.all([
        ...(this.alertConditionTypes.length ? [] : [this.findAlertConditionTypes()])
      ])
      if (this.defaultSelectAll && !(this.value && this.value.length)) {
        this.selectAll()
      }
      this.initialLoading = false
    } catch (e) {
      this.initialLoading = false
    }
  }
}
</script>
